export default __webpack_public_path__ + "static/media/pbi7.4cee5b74.JPG";